'use strict';

module.exports = function () {
  return global.location.protocol === 'http:';
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/~/braintree-web/client/request/is-http.js
// module id = 791
// module chunks = 0